"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pushtext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const pushtext_style_1 = __importDefault(require("./pushtext.style"));
class Pushtext extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            if (!this.props.disabled)
                this.props.onClick();
        };
        this.render = () => {
            const { classes, children, disabled, hasPopup, mute, warning, textRef: ref, prefix, suffix, dataCy } = this.props;
            const rootProps = {
                onClick: this.handleClick,
                type: 'button',
                className: classes.root,
                disabled,
                ref,
                'data-is-muted': mute,
                'data-is-warning': warning,
                'aria-haspopup': hasPopup,
                'data-cy': dataCy || 'atomic-button'
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
                    jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: children }), void 0),
                    suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }), void 0));
        };
    }
}
exports.Pushtext = Pushtext;
Pushtext.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    textRef: prop_types_1.default.func,
    hasPopup: prop_types_1.default.bool,
    mute: prop_types_1.default.bool,
    warning: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    prefix: prop_types_1.default.node,
    suffix: prop_types_1.default.node,
    dataCy: prop_types_1.default.string
};
Pushtext.defaultProps = {
    disabled: false,
    hasPopup: false,
    mute: false,
    warning: false,
    textRef: null,
    prefix: null,
    suffix: null,
    dataCy: ''
};
exports.default = react_jss_1.default(pushtext_style_1.default)(Pushtext);
//# sourceMappingURL=pushtext.js.map